module.exports = __webpack_public_path__ + "dingbeauty-landing/img/logo_white.bacd1048.svg";